import createLucideIcon from '../createLucideIcon';

const Codepen = createLucideIcon('Codepen', [
  [
    'polygon',
    { points: '12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2', key: 'srzb37' },
  ],
  ['line', { x1: '12', x2: '12', y1: '22', y2: '15.5', key: '1t73f2' }],
  ['polyline', { points: '22 8.5 12 15.5 2 8.5', key: 'ajlxae' }],
  ['polyline', { points: '2 15.5 12 8.5 22 15.5', key: 'susrui' }],
  ['line', { x1: '12', x2: '12', y1: '2', y2: '8.5', key: '2cldga' }],
]);

export default Codepen;
